<template>
	
<div id="paySuccess">
	<normalBar title="下单成功"></normalBar>
	<div class="paySuc-sec">
		<div class="suc-img">
			<span class="text">付款成功</span>
			<img src="../../assets/images/success.png" alt="">
		</div>

		<div v-if="infoComplete">
			<p class="tips">订单已成功提交，感谢您的购买！</p>
			<div class="suc-operate-group">
				<span class="op-items"><router-link to="/home">返回首页</router-link></span>
				<span class="op-items" @click="goCheckOrder">查看订单</span>
			</div>
		</div>

		<div v-else>
			<p class="tips">订单已成功提交，感谢您的购买！<br/>您还没有完善您的个人资料，快去完善吧</p>
			<div class="suc-operate-group">
				<span class="op-items"  @click="goCheckOrder">查看订单</span>
				<span class="op-items"><router-link to="/userAccountSet/info">完善信息</router-link></span>
			</div>
		</div>
	</div>
<!-- 
	<div class="paySuc-sec" v-else>
		<div class="suc-img">
			<span class="text">支付失败</span>
			<img src="../../assets/images/failed.png" alt="">
		</div>
		<div class="suc-operate-group">
			<span class="op-items"><router-link :to="'/orderDetails/'+mchId">查看订单</router-link></span>
			<span class="op-items" ><router-link to="/home">返回首页</router-link></span>
		</div>
	</div> -->
</div>
</template>
<script>
	import normalBar from '@/components/common/navbar/normalBar'
	import Ajax from '../../api/common/api.common'
	import api from '@/api/api'
	import { mapState } from 'vuex'
	export default {
		data(){
			return {
				success: true,
				mchId: '',
			}
		},
		computed: mapState({
			infoComplete: state => state.user.infoComplete
		}),
		components: {
			normalBar
		},
		created(){
			this.mchId = this.$route.params.mchId;
		},
		methods:{
			goCheckOrder(){
				let self = this;
				this.$router.push({
					path: '/orderDetails/'+self.mchId+'?url=/'
				})
			}
		},
		mounted(){
			let self = this;
			Ajax.getUserInfo({},function (successRsp) {
		        self.$store.dispatch('setUserLogin',successRsp.body.data)
		    },function () {},false)
		}
	}
</script>
<style lang="scss">
	@import '../../assets/css/mixin';
</style>


// WEBPACK FOOTER //
// paySuccess.vue?44ee3701